import Link from 'next/link';

import { ConditionalWrapper } from '@/hoc';

import type { FunctionComponent } from 'react';
import type { TypeColumnProps } from './types';

/**
 * Column
 */
export const Column: FunctionComponent<TypeColumnProps> = ({
  className = '',
  title,
  menu,
}: TypeColumnProps) => (
  <div className="flex flex-col gap-4">
    {title && (
      <ConditionalWrapper
        // @ts-ignore
        condition={Boolean(title?.href)}
        wrapper={(children) => (
          // @ts-ignore
          <Link href={title.href} legacyBehavior prefetch={false}>
            <a className="text-text-neutrals-0 hover:opacity-80">{children}</a>
          </Link>
        )}
      >
        <span className="text-body text-body-l font-bold">
          {
            // @ts-ignore
            title?.label || title
          }
        </span>
      </ConditionalWrapper>
    )}

    {menu && (
      <div
        className={`text-body text-body-m text-neutrals-0 flex flex-col gap-2 md:gap-4 ${className}`}
      >
        {menu?.map((item, index: number) => (
          <Link key={index} href={item.href} legacyBehavior>
            <a className="text-text-neutrals-0 py-1 hover:opacity-80 md:py-0">
              {item.label}
            </a>
          </Link>
        ))}
      </div>
    )}
  </div>
);

Column.displayName = 'Column';
